import { KEY_DOWN_EVENT } from '../../../etc/constants';
import { updateState } from '../../state';

export function toggleKeys(state, action) {
  let event = state.mouse.lastMove;

  if (state.mouse.lastMove != null) {
    const toggle = action.type === KEY_DOWN_EVENT;

    if (action.key === 'Control') {
      event = updateState(event, { ctrlKey: toggle });
    } else if (action.key === 'Alt') {
      event = updateState(event, { altKey: toggle });
    } else if (action.key === 'Shift') {
      event = updateState(event, { shiftKey: toggle });
    }
  }

  return { mouse: updateState(state.mouse, { lastMove: event }) };
}
